import { useEffect, useState } from 'react';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import Chart from 'react-apexcharts'

const Statistic = ({ businessRank }) => {    

    const { readData: getReport } = useEntityCrud('Report/getStatistic');
    const [transactions,setTransactions] = useState([]);
    const [transactionsChart,setTransactionsChart] = useState();
    const [businesses,setBusinesses] = useState([]);
    const [businessesChart,setBusinessesChart] = useState({});
    const [cardMembers,setCardMembers] = useState([]);
    const [appMembers,setAppMembers] = useState([]);
    const [orders,setOrders] = useState([]);
    const [ordersChart,setOrdersChart] = useState({});
    const [nationalCode,setNationalCode] = useState('');
    const { readData: getLastLogins } = useEntityCrud(`User/getLastLogins?username=${nationalCode}`);
    const [loginList,setLoginList] = useState(null);
    const currentUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
    const { readData: getSuccess } = useEntityCrud('Report/SuccessTrxStat?trx_type=1');
    const { readData: getUnSuccess } = useEntityCrud('Report/UnSuccessTrxStat?trx_type=2');
    const [success,setSuccess] = useState([]);
    const [unsuccess,setUnSuccess] = useState([]);

    useEffect(() => {
        getReport({p_type: '1'}).then(({data}) => {
            if(data.status)
                setTransactions(data.result.v_result)
        })
        getReport({p_type: '2'}).then(({data}) => {
            if(data.status)
                setBusinesses(data.result.v_result)
        })
        getReport({p_type: '3'}).then(({data}) => {
            if(data.status)
                setCardMembers(data.result.v_result)
        })
        getReport({p_type: '4'}).then(({data}) => {
            if(data.status)
                setAppMembers(data.result.v_result)
        })
        getReport({p_type: '5'}).then(({data}) => {
            if(data.status)
                setOrders(data.result.v_result)
        })
        if(Object.keys(currentUser).length && currentUser.username == '0080600476'){
            getSuccess().then(({data}) => {
                if(data.status)
                    setSuccess(data.result.v_result)
            });
            getUnSuccess().then(({data}) => {
                if(data.status)
                    setUnSuccess(data.result.v_result)
            });
        }
    },[])

    useEffect(() => {
        if(Object.keys(currentUser).length && currentUser.roleId != 1){
            setNationalCode(currentUser.username)
        }
    },[currentUser.username])

    useEffect(() => {
        if(nationalCode)
            getLastLoginList()
    },[nationalCode])

    useEffect(() => {
        if(transactions && transactions.length){
            const series = []
            const labels = []
            transactions.map(tr => {
                series.push(tr.cnt)
                labels.push(' ' + tr.title + ' ')
            })
            setTransactionsChart({
                series,
                options: {
                    labels,
                    chart: {
                        type: 'donut',
                    },
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                }
            })
        }
    },[transactions])

    useEffect(() => {
        if(businesses && businesses.length){
            const series = []
            const labels = []
            businesses.map(bu => {
                series.push(bu.cnt)
                labels.push(' ' + bu.title + ' ')
            })
            setBusinessesChart({
                series,
                options: {
                    labels,
                    chart: {
                        type: 'donut',
                    },
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                }
            })
        }
    },[businesses])

    useEffect(() => {
        if(orders && orders.length){
            const series = []
            const labels = []
            orders.map(or => {
                series.push(or.cnt)
                labels.push(' ' + or.title + ' ')
            })
            setOrdersChart({
                series,
                options: {
                    labels,
                    chart: {
                        type: 'donut',
                    },
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                }
            })
        }
    },[orders])

    const getLastLoginList = () => {
        getLastLogins().then(({data}) => {
            if(data.status)
                setLoginList(data.result);
            else
                setLoginList([]);
        })
    }

    return (
        <div className="row">
            {success.length && unsuccess.length ? <>
                <div className="col-12">
                    <div className="row">
                        {success?.map(r => <div class="col-md-12 mb-2"><div className="alert alert-success">
                            <p className="mb-0"><b>{r.title} : </b>{r.cnt} عدد</p>
                        </div></div>)}
                    </div>
                </div>
                <div className="col-12">
                    <div className="row justify-content-center">
                        {unsuccess?.map(r => <div class="col-md-4 mb-2"><div className="alert alert-danger">
                            <p className="mb-0"><b>{r.title} با کد {r.response_code} : </b>{r.cnt} عدد</p>
                        </div></div>)}
                    </div>
                </div>
                <div className="col-12">
                    <hr />
                </div>
            </> : ''}
            {currentUser?.roleId == 1 && <div className="col-md-6 mb-4">
                <div className="alert alert-info">
                    <p><b>{cardMembers[0]?.title}</b> : {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(cardMembers[0]?.cnt)}</p>
                </div>
            </div>}
            {currentUser?.roleId == 1 && <div className="col-md-6 mb-4">
                <div className="alert alert-info">
                    <p><b>{appMembers[0]?.title}</b> : {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(appMembers[0]?.cnt)}</p>
                </div>
            </div>}
            {currentUser?.roleId == 1 && <div className="col-md-4">
                <div className="card">
                    <div className="card-header">
                        <div className="card-title">تعداد تراکنش ها</div>
                    </div>
                    <div className="card-body">
                        {transactionsChart && Object.keys(transactionsChart).length && <Chart
                            options={transactionsChart.options}
                            series={transactionsChart.series}
                            type="donut"
                            width="100%"
                        />}
                        {/* <ul style={{lineHeight: 2.5}}>
                            {transactions.map((item,index) => 
                                <li key={`tr-${index}`}>{item.title} : {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(item.cnt)}</li>
                            )}
                        </ul> */}
                    </div>
                </div>
            </div>}
            {currentUser?.roleId == 1 && <div className="col-md-4">
                <div className="card">
                    <div className="card-header">
                        <div className="card-title">تعداد کسب و کار ها</div>
                    </div>
                    <div className="card-body">
                        {businessesChart && Object.keys(businessesChart).length && <Chart
                            options={businessesChart.options}
                            series={businessesChart.series}
                            type="donut"
                            width="100%"
                        />}
                        {/* <ul style={{lineHeight: 2.5}}>
                            {businesses.map((item,index) => 
                                <li key={`br-${index}`}>{item.title} : {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(item.cnt)}</li>
                            )}
                        </ul> */}
                    </div>
                </div>
            </div>}
            {currentUser?.roleId == 1 && <div className="col-md-4">
                <div className="card">
                    <div className="card-header">
                        <div className="card-title">تعداد سفارشات</div>
                    </div>
                    <div className="card-body">
                        {ordersChart && Object.keys(ordersChart).length && <Chart
                            options={ordersChart.options}
                            series={ordersChart.series}
                            type="donut"
                            width="100%"
                        />}
                        {/* <ul style={{lineHeight: 2.5}}>
                            {orders.map((item,index) => 
                                <li key={`or-${index}`}>{item.title} : {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(item.cnt)}</li>
                            )}
                        </ul> */}
                    </div>
                </div>
            </div>}
            {businessRank > 0 && <div className="col-12 mb-4">
                <div className="alert alert-light">
                    <p className="mb-0 text-dark" style={{fontSize: 15}}><i className="fa fa-star me-2" style={{color: 'gold',fontSize: 16}}></i>امتیاز فعلی کسب و کار شما : {businessRank}</p>
                </div>
            </div>}
            <div className="col-12">
                <div className="card">
                    <div className="card-header">
                        <div className="card-title">دریافت لیست ده ورود آخر کاربران به پنل</div>
                    </div>
                    <div className="card-body">
                        {currentUser?.roleId == 1 && <div className="row">
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>نام کاربری (کد ملی)</label>
                                    <input type="text" className="form-control ltr-input" maxLength={10} value={nationalCode} onChange={e => setNationalCode(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-2" style={{marginTop: 29}}>
                                <button className="btn btn-success" disabled={nationalCode.length != 10} onClick={getLastLoginList}>جستجو</button>
                            </div>
                        </div>}
                        {loginList !== null && currentUser?.roleId == 1 && loginList.length ? <hr className="mt-1 mb-5" /> : ''}
                        {loginList !== null && loginList.length ? <div className="table-responsive">
                            <table className="table table-hover table-bordered">
                                <thead>
                                    <tr>
                                        <th>ردیف</th>
                                        <th>نام و نام خانوادگی</th>
                                        <th>نام کاربری</th>
                                        <th>تاریخ</th>
                                        <th>ساعت</th>
                                        <th>وضعیت</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loginList.map((item,index) => <tr key={index}>
                                        <td>{++index}</td>
                                        <td>{item.fullName}</td>
                                        <td>{item.username}</td>
                                        <td>{new Date(item.eventDate.split('T')[0]).toLocaleDateString('fa-IR')}</td>
                                        <td>{item.eventDate.split('T')[1]}</td>
                                        {item.status ? <td className="text-success">موفق</td> : <td className="text-danger">ناموفق</td>}
                                    </tr>)}
                                </tbody>
                            </table>
                        </div> : (loginList !== null ? <div className="alert alert-info"><p className="mb-0">داده ای یافت نشد</p></div> : '')}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Statistic